export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '13133efc-826b-47b4-ab8c-e9e04fb4fb4e';
export const MODAL_CLOSE_SEC = 2.5;
